import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Affected' })({
    root: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 24px 12px 24px',
        gap: 16,
        background: '#232323',
        borderRadius: 16,
        '& pre': {
            margin: '0',
            whiteSpace: 'break-spaces'
        }
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    code: {
        fontFeatureSettings: '"liga" off, "clig" off',
        fontDamily: 'Azeret Mono',
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '160%',
        background: 'inherit !important',
        color: '#FFFFFF',
        ['& .hljs-string']: {
            color: '#F5726A'
        },
        ['& .hljs-attr']: {
            color: '#94C7FF'
        }
    },
    labelRoot: {
        width: 155
    },
    labelSelect: {
        textAlign: 'start'
    }
});
